<div
  class="flex flex-col space-y-4 w-full"
  [formGroup]="form"
  *ngIf="xeroAccounts && form; else loadingMessage"
>
  <div class="flex flex-col space-y-4 w-full">
    <!--    SALES   -->
    <h2 class="pt-4">Sales</h2>
    <div class="flex flex-row space-x-4 w-full items-center">
      <p class="w-1/3 flex-shrink-0 flex-grow-0 flex">Hires:</p>
      <mat-form-field class="flex flex-grow">
        <mat-label>Sales/Revenue Account</mat-label>
        <mat-select
          [formControlName]="
            'xero_' + accountConfigKeys.HIRE_SALES_REVENUE_CODE
          "
        >
          <ng-container *ngFor="let account of salesRevenueAccounts">
            <mat-option [value]="account.code">
              {{ account.code }} - {{ account.name }}
            </mat-option>
          </ng-container>
          <mat-option
            (click)="
              createNewAccount(
                $event,
                accountConfigKeys.HIRE_SALES_REVENUE_CODE
              )
            "
          >
            <i>Create New Account</i>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex flex-row space-x-4 w-full items-center">
      <p class="w-1/3 flex-shrink-0 flex-grow-0 flex">Consumables:</p>
      <mat-form-field class="flex flex-grow">
        <mat-label>Sales/Revenue Account</mat-label>
        <mat-select
          [formControlName]="
            'xero_' + accountConfigKeys.CONSUMABLE_SALES_REVENUE_CODE
          "
        >
          <ng-container *ngFor="let account of salesRevenueAccounts">
            <mat-option [value]="account.code">
              {{ account.code }} - {{ account.name }}
            </mat-option>
          </ng-container>
          <mat-option
            (click)="
              createNewAccount(
                $event,
                accountConfigKeys.CONSUMABLE_SALES_REVENUE_CODE
              )
            "
          >
            <i>Create New Account</i>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex flex-row space-x-4 w-full items-center">
      <p class="w-1/3 flex-shrink-0 flex-grow-0 flex">Deliveries:</p>
      <mat-form-field class="flex flex-grow">
        <mat-label>Sales/Revenue Account</mat-label>
        <mat-select
          [formControlName]="'xero_' + accountConfigKeys.DELIVERY_REVENUE_CODE"
        >
          <ng-container *ngFor="let account of salesRevenueAccounts">
            <mat-option [value]="account.code">
              {{ account.code }} - {{ account.name }}
            </mat-option>
          </ng-container>
          <mat-option
            (click)="
              createNewAccount($event, accountConfigKeys.DELIVERY_REVENUE_CODE)
            "
          >
            <i>Create New Account</i>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex flex-row space-x-4 w-full items-center">
      <p class="w-1/3 flex-shrink-0 flex-grow-0 flex">Retail Sales:</p>
      <mat-form-field class="flex flex-grow">
        <mat-label>Sales/Revenue Account</mat-label>
        <mat-select
          [formControlName]="
            'xero_' + accountConfigKeys.RETAIL_SALES_REVENUE_CODE
          "
        >
          <ng-container *ngFor="let account of salesRevenueAccounts">
            <mat-option [value]="account.code">
              {{ account.code }} - {{ account.name }}
            </mat-option>
          </ng-container>
          <mat-option
            (click)="
              createNewAccount(
                $event,
                accountConfigKeys.RETAIL_SALES_REVENUE_CODE
              )
            "
          >
            <i>Create New Account</i>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex flex-row space-x-4 w-full items-center">
      <p class="w-1/3 flex-shrink-0 flex-grow-0 flex">Repair Parts:</p>
      <mat-form-field class="flex flex-grow">
        <mat-label>Sales/Revenue Account</mat-label>
        <mat-select
          [formControlName]="
            'xero_' + accountConfigKeys.REPAIR_PARTS_REVENUE_CODE
          "
        >
          <ng-container *ngFor="let account of salesRevenueAccounts">
            <mat-option [value]="account.code">
              {{ account.code }} - {{ account.name }}
            </mat-option>
          </ng-container>
          <mat-option
            (click)="
              createNewAccount(
                $event,
                accountConfigKeys.REPAIR_PARTS_REVENUE_CODE
              )
            "
          >
            <i>Create New Account</i>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex flex-row space-x-4 w-full items-center">
      <p class="w-1/3 flex-shrink-0 flex-grow-0 flex">Repair Labour:</p>
      <mat-form-field class="flex flex-grow">
        <mat-label>Sales/Revenue Account</mat-label>
        <mat-select
          [formControlName]="
            'xero_' + accountConfigKeys.REPAIR_LABOUR_REVENUE_CODE
          "
        >
          <ng-container *ngFor="let account of salesRevenueAccounts">
            <mat-option [value]="account.code">
              {{ account.code }} - {{ account.name }}
            </mat-option>
          </ng-container>
          <mat-option
            (click)="
              createNewAccount(
                $event,
                accountConfigKeys.REPAIR_LABOUR_REVENUE_CODE
              )
            "
          >
            <i>Create New Account</i>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex flex-row space-x-4 w-full items-center">
      <p class="w-1/3 flex-shrink-0 flex-grow-0 flex">
        Sales of Hire Equipment:
      </p>
      <mat-form-field class="flex flex-grow">
        <mat-label>Sales/Revenue Account</mat-label>
        <mat-select
          [formControlName]="
            'xero_' + accountConfigKeys.HIRE_EQUIPMENT_SALES_REVENUE_CODE
          "
        >
          <ng-container *ngFor="let account of salesRevenueAccounts">
            <mat-option [value]="account.code">
              {{ account.code }} - {{ account.name }}
            </mat-option>
          </ng-container>
          <mat-option
            (click)="
              createNewAccount(
                $event,
                accountConfigKeys.HIRE_EQUIPMENT_SALES_REVENUE_CODE
              )
            "
          >
            <i>Create New Account</i>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!--    PURCHASES -->
    <h2 class="pt-4">Purchases</h2>
    <div class="flex flex-row space-x-4 w-full items-center">
      <p class="w-1/3 flex-shrink-0 flex-grow-0 flex">Retail Purchases:</p>
      <mat-form-field class="flex flex-grow">
        <mat-label>Direct Cost Account</mat-label>
        <mat-select
          [formControlName]="'xero_' + accountConfigKeys.RETAIL_PURCHASES_CODE"
        >
          <ng-container *ngFor="let account of directCostAccounts">
            <mat-option [value]="account.code">
              {{ account.code }} - {{ account.name }}
            </mat-option>
          </ng-container>
          <mat-option
            (click)="
              createNewAccount($event, accountConfigKeys.RETAIL_PURCHASES_CODE)
            "
          >
            <i>Create New Account</i>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex flex-row space-x-4 w-full items-center">
      <p class="w-1/3 flex-shrink-0 flex-grow-0 flex">Consumable Purchases:</p>
      <mat-form-field class="flex flex-grow">
        <mat-label>Direct Cost Account</mat-label>
        <mat-select
          [formControlName]="
            'xero_' + accountConfigKeys.CONSUMABLE_PURCHASE_CODE
          "
        >
          <ng-container *ngFor="let account of directCostAccounts">
            <mat-option [value]="account.code">
              {{ account.code }} - {{ account.name }}
            </mat-option>
          </ng-container>
          <mat-option
            (click)="
              createNewAccount(
                $event,
                accountConfigKeys.CONSUMABLE_PURCHASE_CODE
              )
            "
          >
            <i>Create New Account</i>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex flex-row space-x-4 w-full items-center">
      <p class="w-1/3 flex-shrink-0 flex-grow-0 flex">
        Hire Equipment Purchases:
      </p>
      <mat-form-field class="flex flex-grow">
        <mat-label>Direct Cost Account</mat-label>
        <mat-select
          [formControlName]="
            'xero_' + accountConfigKeys.HIRE_EQUIPMENT_PURCHASES_CODE
          "
        >
          <ng-container *ngFor="let account of directCostAccounts">
            <mat-option [value]="account.code">
              {{ account.code }} - {{ account.name }}
            </mat-option>
          </ng-container>
          <mat-option
            (click)="
              createNewAccount(
                $event,
                accountConfigKeys.HIRE_EQUIPMENT_PURCHASES_CODE
              )
            "
          >
            <i>Create New Account</i>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!--    PAYMENTS -->
    <h2 class="pt-4">Payments</h2>
    <div class="flex flex-row space-x-4 w-full items-center">
      <p class="w-1/3 flex-shrink-0 flex-grow-0 flex">
        Bank Transfers Received:
      </p>
      <mat-form-field class="flex flex-grow">
        <mat-label>Bank / Payment Enabled Account</mat-label>
        <mat-select
          [formControlName]="'xero_' + accountConfigKeys.BANK_TRANSFER_PAYMENTS"
        >
          <ng-container *ngFor="let account of paymentableAccounts">
            <mat-option [value]="account.xero_id">
              {{ account.name }}
            </mat-option>
          </ng-container>
          <mat-option
            (click)="
              createNewAccount($event, accountConfigKeys.BANK_TRANSFER_PAYMENTS)
            "
          >
            <i>Create New Account</i>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex flex-row space-x-4 w-full items-center">
      <p class="w-1/3 flex-shrink-0 flex-grow-0 flex">
        Card Payments Received:
      </p>
      <mat-form-field class="flex flex-grow">
        <mat-label>Bank / Payment Enabled Account</mat-label>
        <mat-select
          [formControlName]="'xero_' + accountConfigKeys.CARD_PAYMENTS"
        >
          <ng-container *ngFor="let account of paymentableAccounts">
            <mat-option [value]="account.xero_id">
              {{ account.name }}
            </mat-option>
          </ng-container>
          <mat-option
            (click)="createNewAccount($event, accountConfigKeys.CARD_PAYMENTS)"
          >
            <i>Create New Account</i>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex flex-row space-x-4 w-full items-center">
      <p class="w-1/3 flex-shrink-0 flex-grow-0 flex">
        {{ defaultCurrency }} Cash Payments Received:
      </p>
      <mat-form-field class="flex flex-grow">
        <mat-label>Bank / Payment Enabled Account</mat-label>
        <mat-select
          [formControlName]="
            'xero_' + accountConfigKeys.CASH_PAYMENTS_PREFIX + defaultCurrency
          "
        >
          <ng-container *ngFor="let account of paymentableAccounts">
            <mat-option [value]="account.xero_id">
              {{ account.name }}
            </mat-option>
          </ng-container>
          <mat-option
            (click)="
              createNewAccount(
                $event,
                accountConfigKeys.CASH_PAYMENTS_PREFIX + defaultCurrency
              )
            "
          >
            <i>Create New Account</i>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex flex-row space-x-4 w-full items-center">
      <p class="w-1/3 flex-shrink-0 flex-grow-0 flex">
        {{ defaultCurrency }} Cheque Payments Received:
      </p>
      <mat-form-field class="flex flex-grow">
        <mat-label>Bank / Payment Enabled Account</mat-label>
        <mat-select
          [formControlName]="
            'xero_' + accountConfigKeys.CHEQUE_PAYMENTS_PREFIX + defaultCurrency
          "
        >
          <ng-container *ngFor="let account of paymentableAccounts">
            <mat-option [value]="account.xero_id">
              {{ account.name }}
            </mat-option>
          </ng-container>
          <mat-option
            (click)="
              createNewAccount(
                $event,
                accountConfigKeys.CHEQUE_PAYMENTS_PREFIX + defaultCurrency
              )
            "
          >
            <i>Create New Account</i>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <ng-container *ngFor="let currency of additionalCurrencies">
      <div class="flex flex-row space-x-4 w-full items-center">
        <p class="w-1/3 flex-shrink-0 flex-grow-0 flex">
          {{ currency }} Cash Payments Received:
        </p>
        <mat-form-field class="flex flex-grow">
          <mat-label>Bank / Payment Enabled Account</mat-label>
          <mat-select
            [formControlName]="
              'xero_' + accountConfigKeys.CASH_PAYMENTS_PREFIX + currency
            "
          >
            <ng-container *ngFor="let account of paymentableAccounts">
              <mat-option [value]="account.xero_id">
                {{ account.name }}
              </mat-option>
            </ng-container>
            <mat-option
              (click)="
                createNewAccount(
                  $event,
                  accountConfigKeys.CASH_PAYMENTS_PREFIX + currency
                )
              "
            >
              <i>Create New Account</i>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="flex flex-row space-x-4 w-full items-center">
        <p class="w-1/3 flex-shrink-0 flex-grow-0 flex">
          {{ currency }} Cheque Payments Received:
        </p>
        <mat-form-field class="flex flex-grow">
          <mat-label>Bank / Payment Enabled Account</mat-label>
          <mat-select
            [formControlName]="
              'xero_' + accountConfigKeys.CHEQUE_PAYMENTS_PREFIX + currency
            "
          >
            <ng-container *ngFor="let account of paymentableAccounts">
              <mat-option [value]="account.xero_id">
                {{ account.name }}
              </mat-option>
            </ng-container>
            <mat-option
              (click)="
                createNewAccount(
                  $event,
                  accountConfigKeys.CHEQUE_PAYMENTS_PREFIX + currency
                )
              "
            >
              <i>Create New Account</i>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </ng-container>
  </div>
</div>
<ng-template #loadingMessage>
  <div fxLayout="row" fxFlex="0 0 400px" fxLayoutAlign="center center">
    <div fxFlex="0 0 600px" fxLayout="column" fxLayoutAlign="center center">
      <div fxFlex="row" fxLayoutAlign="center center">
        <p class="text-center" fxFlex="0 0 75">
          Fetching available accounts from Xero
        </p>
      </div>
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  </div>
</ng-template>
